import { Indicator } from '@artprov/design-system'
import PropTypes from 'prop-types'
import { formatToARS } from '../../../../../utils/number.utils'

export default function ResumenSolicitud({ data = {} }) {
    const { fecha, importe, estado, rg_id, nombreSolicitante } = data

    return (
        <div className='grid grid-cols-3 gap-x-4 gap-y-2 w-full mt-2 mb-4'>
            <Indicator
                icon={"content_paste"}
                variant="small"
                text='Número de solicitud' title={rg_id} />

            <Indicator
                icon={"calendar_month"}
                variant="small"
                text='Fecha de solicitud' title={fecha} />

            <Indicator
                icon={"account_circle"}
                variant="small"
                text='Solicitante'
                title={nombreSolicitante ? nombreSolicitante.split(" (")[0] : "no data"}
            />

            <Indicator
                icon={"schedule"}
                variant="small"
                text='Estado de solicitud'
                title={estado}
            />

            <Indicator
                icon={"request_quote"}
                variant="small"
                text='Tipo de solicitud'
                title='Reintegro en cuenta'
            />

            <Indicator
                icon={"attach_money"}
                variant="small"
                text='Importe total'
                title={(formatToARS(importe) || "no data")}
            />
        </div>
    )
}
ResumenSolicitud.propTypes = {
    data: PropTypes.object
}
